import * as customerActions from '../actions/customer-actions';

const initialState = {
  device: {
    kind: 1,
    code: null,
  },
  loggedIn: false,
  token: null,
  errors: null,
  pswdResetRequestSend: false,
  messages: [],
  loading: false,
  allLoans: [],
  autoApproval: null,
  installmentSimulation: null,
  installmentUpdated: null,
  messagePreferences: null,
  underwriting: null,
  displayBanner: false,
  insuranceInfo: null,
};

/**
 * Loan reducer.
 * @param {*} state Current state.
 * @param {*} action Action to be perfomed.
 */
export default function customer(state = initialState, action) {
  // Processes new state.
  let newState;
  switch (action.type) {
    // If it is a device success action.
    case customerActions.DEVICE_SUCCESS:
      newState = {
        ...state,
        device: {
          kind: action.payload.kind,
          code: action.payload.code,
        },
      };
      return newState;
    // If it is a current loan success action.
    case customerActions.FIND_CURRENT_LOAN_SUCCESS:
      newState = {
        ...state,
      };
      return newState;

    // If it is a current loan failure action.
    case customerActions.FIND_CURRENT_LOAN_FAILURE:
      newState = { ...state };
      return newState;

    case customerActions.AUTO_APPROVAL_SUCCESS:
      newState = {
        ...state,
        autoApproval: action.payload,
      };
      return newState;

    case customerActions.AUTO_APPROVAL_FAILURE:
      newState = { ...state };
      return newState;

    // By default.
    case customerActions.FIND_ALL_LOAN_SUCCESS:
      newState = {
        ...state,
        allLoans: action.payload,
      };
      return newState;

    case customerActions.INSTALLMENT_SIMULATION_SUCCESS:
      newState = {
        ...state,
        installmentSimulation: action.payload[0],
      };
      return newState;

    case customerActions.INSTALLMENT_SIMULATION_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
      };
      return newState;

    case customerActions.INSTALLMENT_UPDATE_SUCCESS:
      newState = {
        ...state,
        installmentUpdated: action.payload,
      };
      return newState;

    case customerActions.INSTALLMENT_UPDATE_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
      };
      return newState;

    case customerActions.GET_MESSAGE_PREFERENCES_SUCCESS:
      newState = {
        ...state,
        messagePreferences: action.payload,
      };
      return newState;

    case customerActions.GET_MESSAGE_PREFERENCES_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
      };
      return newState;

    case customerActions.UPDATE_MESSAGE_PREFERENCES_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
      };
      return newState;

    case customerActions.GET_UNDERWRITING_SUCCESS:
      newState = {
        ...state,
        underwriting: action.payload,
      };
      return newState;

    case customerActions.REQUEST_APP_INSTALLATION_SUCCESS:
      newState = {
        ...state,
        errors: null,
        loan: action.payload,
      };
      return newState;

    case customerActions.REQUEST_APP_INSTALLATION_FAILURE:
      newState = {
        ...state,
        errors: action.payload,
      };
      return newState;

    case customerActions.PARTNER_BANNER_SUCCESS:
      return { ...state, displayBanner: action.payload };

    case customerActions.PARTNER_BANNER_FAILURE:
      return { ...state, displayBanner: true };

    case customerActions.GET_INSURANCE_INFO_SUCCESS:
    case customerActions.CANCEL_INSURANCE_SUCCESS:
      return { ...state, insuranceInfo: action.payload };

    case customerActions.GET_INSURANCE_INFO_FAILURE:
      return { ...state, insuranceInfo: null };

    case customerActions.GET_EBS_URL_SUCCESS:
      if (typeof action.payload === 'string') {
        return { ...state, ebsUrl: action.payload };
      }
        return state;

    default:
      return { ...state };
  }
}
